<style>
    .collapse-a:before {
        font-family: "Font Awesome 5 Free";
        content: "\f067";
        margin-left: 10px
    }

    .collapse-a .collapse-a-title:before {
        content: "جزئیات بیشتر";
    }

    .collapse-a.lessDetails:before {
        font-family: "Font Awesome 5 Free";
        content: "\f068";
        margin-left: 10px
    }

    .collapse-a.lessDetails .collapse-a-title:before {
        content: "جزئیات کمتر";
    }

    .v-select ul li {
        padding: 10px 5px !important
    }
</style>
<template>
    <div id="page">
        <div class="page-content pb-0">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>گفتگوی شماره {{conversation.conversationNo}}</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>



            <div class="card card-style">
                <div class="content">
                    <ul class="nav nav-pills justify-content-center" id="pills-tab" role="tablist">
                        <li class="nav-item flex-1" role="presentation">
                            <button class="nav-link text-center rounded-s active w-100" :class="{'active':activeTabTitle=='#pills-details'}" id="pills-details-tab" data-toggle="pill" data-target="#pills-details" role="tab" aria-controls="pills-details" aria-selected="true" style="border: 1px solid #528edd">گفتگو</button>
                        </li>

                        <li class="nav-item flex-1" role="presentation">
                            <button class="nav-link text-center rounded-s w-100" :class="{'active':activeTabTitle=='#pills-att'}" id="pills-att-tab" data-toggle="pill" data-target="#pills-att" role="tab" aria-controls="pills-att" aria-selected="false" style="border: 1px solid #528edd">ضمائم گفتگو</button>
                        </li>
                    </ul>
                    <div class="tab-content mt-3" id="pills-tabContent">
                        <div class="tab-pane fade active show" id="pills-details" :class="{'active show':activeTabTitle=='#pills-details'}" role="tabpanel" aria-labelledby="pills-details-tab">
                            <div class="collapse pt-3" id="collapse-moreDetails">
                                <div class="input-style input-style-2 has-icon input-required mb-3">
                                    <i class="input-icon fa fa-user color-magenta2-light"></i>
                                    <span class="color-highlight input-style-1-active">شماره</span>
                                    <input class="form-control text-left" v-model="conversation.conversationNo" readonly type="text">
                                </div>

                                <div class="input-style input-style-2 has-icon input-required mb-3">
                                    <i class="input-icon fa fa-user color-magenta2-light"></i>
                                    <span class="color-highlight input-style-1-active">زمان</span>
                                    <input class="form-control text-left" v-model="conversation.conversationDateTime" readonly type="text">
                                </div>

                                <div class="input-style input-style-2 has-icon input-required mb-3">
                                    <i class="input-icon fa fa-user color-magenta2-light"></i>
                                    <span class="color-highlight input-style-1-active">موضوع</span>
                                    <input class="form-control" v-model="conversation.subject" type="text">
                                </div>

                                <div class="mb-3" v-if="conversation.taskFolderId==null">
                                    <v-select dir="rtl" label="userTitle" placeholder="گیرندگان" multiple chips :options="OrgUnitUserList" :reduce="p => p.userId" v-model="conversation.users">
                                        <template slot="option">
                                            <div class="d-center">
                                                {{ option.userCode }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>

                                <div class="mb-3" v-else>
                                    <div class="input-style input-style-2 has-icon input-required mb-3">
                                        <i class="input-icon fa fa-user color-magenta2-light"></i>
                                        <span class="color-highlight">گیرندگان</span>
                                        <input class="form-control" v-model="conversation.strUserTitle" readonly type="text">
                                    </div>
                                </div>
                                <div class="mb-3" v-if="!isMinVersion">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="conversation.personId" label="title" @option:selected="onchangePerson" placeholder="شخص/شرکت" :filter="PersonFilter" :options="PersonList" :reduce="p => p.personId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        {{ option.title }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="conversation.projectId" label="fullTitle" @option:selected="onchangeProject" placeholder="پروژه" :filter="ProjectFilter" :options="ProjectList" :reduce="p => p.projectId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        {{ option.fullTitle }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="conversation.preInvoiceId" label="strDocNo" @option:selected="onchangePreInvoice" placeholder=" پیش فاکتور فروش کالا/خدمات" :filter="PreInvoiceFilter" :options="PreInvoiceList" :reduce="p => p.preInvoiceId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3" v-if="!isMinVersion">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="conversation.contractId" label="strDocNo" @option:selected="onchangeContract" placeholder="قرارداد" :filter="ContractFilter" :options="ContractList" :reduce="p => p.contractId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3" v-if="!isMinVersion">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="conversation.meetingId" label="strDocNo" @option:selected="onchangeMeeting" placeholder="جلسه" :filter="MeetingFilter" :options="MeetingList" :reduce="p => p.meetingId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3" v-if="!isMinVersion">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="conversation.letterId" label="strDocNo" @option:selected="onchangeLetter" placeholder="نامه" :filter="LetterFilter" :options="LetterList" :reduce="p => p.letterId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="conversation.invoiceId" label="strDocNo" @option:selected="onchangeInvoice" placeholder="فاکتور فروش کالا/خدمات" :filter="InvoiceFilter" :options="InvoiceList" :reduce="p => p.invoiceId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>




                                <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                                    <div class="d-flex">
                                        <div class="w-100">
                                            <v-select dir="rtl" v-model="conversation.buyId" label="strDocNo" @option:selected="onchangeBuy" placeholder="خرید کالا/خدمات" :filter="BuyFilter" :options="BuyList" :reduce="p => p.buyId">
                                                <template v-slot="option">
                                                    <div class="d-center">
                                                        <span>{{  option.strDocNo }}</span>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3" v-if="!isMinVersion">

                                    <v-select dir="rtl" label="title" placeholder="کارگروه" :filterable="WorkGroupList.length>10" :searchable="WorkGroupList.length>10" :options="WorkGroupList" :reduce="p => p.workGroupId" v-model="conversation.workGroupId" @option:selected="onChangeWorkGroup">
                                        <template slot="option">
                                            <div class="d-center">
                                                {{ option.title }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                                <button v-if="conversation.taskFolderId==null" :disabled="pageLoading || attInProgress" @click.prevent="SaveConversationRef" type="button" value="ثبت" class="btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100 mb-3">
                                    <i class="fa fa-check font-10 ml-2"></i>
                                    ذخیره تغییرات
                                </button>
                            </div>
                            <button data-toggle="collapse" data-target="#collapse-moreDetails" class="btn btn-xxs mb-3 btn-full rounded-sm bg-highlight font-900 collapse-a w-100" id="moreLessDetails" @click="toggleClasslessDetails()">
                                <span class="collapse-a-title"></span>
                            </button>

                            <div class="conversationBox">
                                <div v-for="item in GetConversationFolders" :key="item.conversationFolderId">
                                    <div v-if="!item.isMe" class="speech-bubble speech-right color-black position-relative">
                                        <span class="d-inline-block ltr ml-2 mb-1">{{item.userTitle}}</span>
                                        <div v-if="item.parentText!=''" class="reply-box">
                                            {{item.parentText}}
                                        </div>
                                        <div class="mb-2 text-muted" v-html="item.description"></div>
                                        <div class="text-muted ltr text-left">{{item.registDateTime}}</div>
                                        <span @click="Reply(item)" class="conversationReplyBtn-1"><i class="fa fa-reply color-green2-light"></i></span>
                                    </div>
                                    <div v-if="!item.isMe" class="clearfix"></div>
                                    <div v-if="item.isMe" class="speech-bubble speech-left brand-bg-color position-relative">
                                        <div v-if="item.parentText!=''" class="reply-box">
                                            {{item.parentText}}
                                        </div>
                                        <div class="speech-bubble-box mb-2" v-html="item.description"></div>
                                        <div class="ltr text-left">{{item.registDateTime}}</div>
                                        <span class="" v-if="item.folderViews!=null" v-html="item.folderViews"></span>
                                        <span class="" v-if="item.viewClass!=null">{{item.viewClass}}</span>
                                        <span @click="Reply(item)" class="conversationReplyBtn-2"><i class="fa fa-reply color-green2-light"></i></span>
                                    </div>
                                    <div v-if="item.isMe" class="clearfix"></div>
                                </div>
                                <div id="endFolder"></div>
                            </div>
                            <div class="card m-0 position-relative" v-if="conversation.closeDateTime==null || conversation.closeDateTime==''">
                                <div class="border-1 p-1 mb-3">
                                    <div class="replyText-box" v-if="replyText!=''">
                                        <span class="font-weight-bold color-black">نام کاربر</span>
                                        <p class="mb-0">{{replyText}}</p>
                                        <span class="replyText-box-close" @click="ReplyClear"><i class="fa font-14 fa-times color-dark1-light"></i></span>
                                    </div>
                                    <div class="d-flex">
                                        <input class="form-control px-2 border-0" v-model="conversation.folderDescription" type="text" placeholder="متن پیام">
                                        <button :disabled="pageLoading || attInProgress" class="btn btn-xxs btn-full bg-green1-dark rounded-sm font-900 btn_checkSmsm" @click="EditConversation" style="min-width:35px">
                                            <i class="fa fa-check font-10"></i>
                                        </button>
                                    </div>
                                </div>
                                <button class="btn btn-link speechToTextBtn" @pointerdown="startR"
                                        @pointerup="stopR">
                                    <span :class="btnRecord">
                                        <span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
                                    </span>
                                    <img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
                                </button>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="pills-att" :class="{'active show':activeTabTitle=='#pills-att'}" role="tabpanel" aria-labelledby="pills-att-tab">
                            <att-list :docId="conversation.conversationId" v-if="conversation.conversationId!=0" v-bind:destination="'Conversation'" @setAttList="SetAttList(conversation)" :canAdd="true" :canDelete="true" :oldAttList="conversation.docAtts" :hasLocation="false"></att-list>
                        </div>
                    </div>


                </div>

                <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
                    <div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
                        <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'
    import AttList from '../Components/AttList.vue';
    import VueSimpleAlert from 'vue3-simple-alert';
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
    export default {
        components: {
            "att-list": AttList
        },
        data() {
            return {
                pageLoading: false,
                attInProgress: false,
                showType: false,
                modified: false,
                replyText: "",
                isLoad: false,
                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",
                conversation: {
                    conversationId: 0,
                    conversationDateTime: "",
                    conversationNo: "",
                    subject: "",
                    description: "",
                    userId: 0,
                    userTitle: "",
                    workGroupTitle: "",
                    taskFolderId: null,
                    taskFolderTitle: "",
                    parentId: null,

                    strUserId: "",
                    createDateTime: "",
                    closeDateTime: "",
                    updateDateTime: "",
                    conversationFolders: [],
                    conversationFolderViews: [],
                    users: [],
                    folderDescription: "",
                    strUserTitle: "",
                    taskId: null,
                    taskDate: "",
                    taskTitle: "",
                    hasNewFolder: false,
                    conversationAttJson: "",
                    closeAfterCreate: false,

                    docAtts: [],
                    attJson: "",





                    workGroupId: null,
                    projectId: null,
                    invoiceId: null,
                    preInvoiceId: null,
                    contractId: null,
                    letterId: null,
                    personId: null,
                    meetingId: null,
                    preBuyInvoiceId: null,
                    buyId: null,

                    projectTitle: null,
                    preInvoiceTitle: null,
                    invoiceTitle: null,
                    letterTitle: null,
                    buyTitle: null,
                    contractTitle: null,
                    personTitle: null,
                    meetingTitle: null,
                    preBuyInvoiceTitle: null,
                    leadTitle: null,
                }
            }
        },
        watch: {
            'conversation.workGroupId'(value) {
                if (this.isLoad)
                    this.onChangeWorkGroup();
            },
            'conversation.personId'(value) {
                if (this.isLoad)
                    this.onchangePerson();
            },
            'conversation.projectId'(value) {
                if (this.isLoad)
                    this.onchangeProject();
            },
            'conversation.preInvoiceId'(value) {
                if (this.isLoad)
                    this.onchangePreInvoice();
            },
            'conversation.contractId'(value) {
                if (this.isLoad)
                    this.onchangeContract();
            },
            'conversation.meetingId'(value) {
                if (this.isLoad)
                    this.onchangeMeeting();
            },
            'conversation.invoiceId'(value) {
                if (this.isLoad)
                    this.onchangeInvoice();
            },
            'conversation.letterId'(value) {
                if (this.isLoad)
                    this.onchangeLetter();
            },
            'conversation.buyId'(value) {
                if (this.isLoad)
                    this.onchangeBuy();
            }

        },
        methods: {
            Reply(item) {
                let text = item.description.replace(/<[^>]*>?/gm, '');
                if (text.length <= 100)
                    this.replyText = text;
                else
                    this.replyText = text.substring(0, 100) + "...";
                this.conversation.parentId = item.conversationFolderId;
            },
            ReplyClear(item) {
                this.replyText = "";
                this.conversation.parentId = null;
            },
            SaveConversationRef() {
                this.pageLoading = true;
                this.$http.post("Conversation/SaveConversationRef", this.conversation)
                    .then(data => {
                        this.pageLoading = false;
                        var res = data.data;
                        if (res.isSuccess) {
                            this.showSuccessMessage(res.message);
                        } else {
                            this.showErrorMessage(res.message);
                        }
                    });
            },
            EditConversation() {
                this.pageLoading = true;
                if (this.conversation.folderDescription != null && this.conversation.folderDescription != '') {
                    this.$http.post("Conversation/EditConversation", this.conversation)
                        .then(data => {
                            this.pageLoading = false;
                            var res = data.data;
                            if (res.isSuccess) {
                                this.conversation.folderDescription = "";
                                this.conversation.parentId = null;
                                this.replyText = "";
                                this.GetConversationItemFolders();
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });
                }
            },
            GetConversationItem(id) {
                this.pageLoading = true;
                this.msg = true;
                this.$http
                    .get("Conversation/GetConversationItem?Id=" + id)


                    .then(data => {
                        this.$store.dispatch("GetPersonListFromServer", {
                            text: "",
                            personId: data.data.personId,
                        }).then(a => {

                            this.$store.dispatch("GetProjectListFromServer", {
                                text: "",
                                personId: data.data.personId,
                                projectId: data.data.projectId,
                            }).then(b => {
                                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                                    text: "",
                                    personId: data.data.personId,
                                    preInvoiceId: data.data.preInvoiceId,
                                }).then(c => {
                                    this.$store.dispatch("GetContractAbstractForPerson", {
                                        personId: data.data.personId,
                                        projectId: data.data.projectId,
                                        contractId: data.data.contractId,
                                    }).then(d => {
                                        this.$store.dispatch("GetInvoiceAbstractForPerson", {
                                            invoiceId: data.data.invoiceId,
                                            preInvoiceId: data.data.preInvoiceId,
                                            contractId: data.data.contractId,
                                            personId: data.data.personId,
                                        }).then(e => {
                                            this.$store.dispatch("GetLetterAbstractForPerson", {
                                                letterId: data.data.letterId,
                                                personId: data.data.personId,
                                            }).then(f => {
                                                this.$store.dispatch("GetMeetingAbstractForPerson", {
                                                    personId: data.data.personId,
                                                    contractId: data.data.contractId,
                                                    projectId: data.data.projectId,
                                                    meetingId: data.data.meetingId,
                                                }).then(g => {
                                                    this.$store.dispatch("GetBuyAbstractForPerson", {
                                                        personId: data.data.personId,
                                                        prebuyInvoiceId: data.data.prebuyInvoiceId,
                                                        buyId: data.data.buyId,
                                                        contractId: data.data.contractId,
                                                    }).then(h => {
                                                        this.$store.dispatch("GetWorkGroupListFromServer", {
                                                            workGroupId: data.data.workGroupId
                                                        }).then(i => {
                                                            var res = data.data;
                                                            this.conversation = res;
                                                            this.pageLoading = false;
                                                            setTimeout(function () {
                                                                let e = document.getElementById("endFolder");
                                                                e.scrollIntoView();
                                                            }, 1000);
                                                            setTimeout(function () {
                                                                this.isLoad = true;
                                                            }, 500);
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });

            },
            GetConversationItemFolders() {
                this.pageLoading = true;
                this.msg = true;
                this.$http
                    .get("Conversation/GetConversationFolderList?Id=" + this.conversation.conversationId)
                    .then(data => {
                        var res = data.data;

                        this.conversation.conversationFolders = res;
                        setTimeout(function () {
                            let e = document.getElementById("endFolder");
                            e.scrollIntoView();
                        }, 500);
                        this.pageLoading = false;
                    });

            },
            SetAttList(e) {
                this.conversation.docAtts = e;
            },
            AttInProgress(e) {
                this.attInProgress = e;
            },
            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    console.error(error);
                    this.showType = true;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }

            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    console.error(error);
                    this.showType = false;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            PersonFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetPersonListFromServer", {
                        text: queryText,
                    });
                return this.$store.getters.GetPersonList;
            },
            onchangePerson() {
                this.conversation.projectId = null;
                this.conversation.invoiceId = null;
                this.conversation.preInvoiceId = null;
                this.conversation.contractId = null;
                this.conversation.letterId = null;
                this.conversation.meetingId = null;
                this.conversation.preBuyInvoiceId = null;
                this.conversation.buyId = null;
                this.$store.dispatch("GetProjectListFromServer", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetContractAbstractForPerson", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetLetterAbstractForPerson", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.conversation.personId,
                });
            },


            ProjectFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetProjectListFromServer", {
                        text: queryText,
                        personId: this.conversation.personId,
                    });
                return this.$store.getters.GetProjectList;
            },
            onchangeProject() {
                this.conversation.contractId = null;
                this.conversation.meetingId = null;
                this.$store.dispatch("GetContractAbstractForPerson", {
                    text: "",
                    personId: this.conversation.personId,
                    projectId: this.conversation.projectId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.conversation.personId,
                    projectId: this.conversation.projectId,
                });
            },


            PreInvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                        text: queryText,
                        personId: this.conversation.personId,
                        projectId: this.conversation.projectId,
                    });
                return this.$store.getters.GetPreInvoiceList;
            },
            onchangePreInvoice() {
                //this.conversation.contractId = null;
                this.conversation.invoiceId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.conversation.preInvoiceId,
                    contractId: this.conversation.contractId,
                    personId: this.conversation.personId,
                });
            },



            ContractFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetContractAbstractForPerson", {
                        text: queryText,
                        personId: this.conversation.personId,
                    });
                return this.$store.getters.GetContractList;
            },
            onchangeContract() {
                this.conversation.invoiceId = null;
                this.conversation.buyId = null;
                this.conversation.meetingId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.conversation.preInvoiceId,
                    contractId: this.conversation.contractId,
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.conversation.personId,
                    projectId: this.conversation.projectId,
                    contractId: this.conversation.contractId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.conversation.personId,
                    prebuyInvoiceId: this.conversation.prebuyInvoiceId,
                    contractId: this.conversation.contractId,
                });

            },



            InvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetInvoiceAbstractForPerson", {
                        text: queryText,
                        preInvoiceId: this.conversation.preInvoiceId,
                        contractId: this.conversation.contractId,
                        personId: this.conversation.personId,
                    });
                return this.$store.getters.GetInvoiceList;
            },
            onchangeInvoice() {
                console.log("")
            },



            LetterFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetLetterAbstractForPerson", {
                        text: queryText,
                        personId: this.conversation.personId,
                    });
                return this.$store.getters.GetLetterList;
            },
            onchangeLetter() {
                console.log("")
            },



            MeetingFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetMeetingAbstractForPerson", {
                        text: queryText,
                        personId: this.conversation.personId,
                        contractId: this.conversation.contractId,
                        projectId: this.conversation.projectId,
                    });
                return this.$store.getters.GetMeetingList;
            },
            onchangeMeeting() {
                console.log("")
            },

            BuyFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetBuyAbstractForPerson", {
                        text: queryText,
                        personId: this.conversation.personId,
                        prebuyInvoiceId: this.conversation.prebuyInvoiceId,
                        contractId: this.conversation.contractId,
                    });
                return this.$store.getters.GetBuyList;
            },
            onchangeBuy() {
                console.log("")
            },





            onChangeWorkGroup() {
                //this.conversation.userId = null;
                //this.$store.dispatch("GetLocalUserListListFromServer", {
                //    workGroupId: this.conversation.workGroupId
                //});
            },
            toggleClasslessDetails() {
                var element = document.getElementById("moreLessDetails");
                element.classList.toggle("lessDetails");
            },
        },
        created() {
            this.$store.dispatch("GetOrgUnitUserList", {});
            this.GetConversationItem(this.$route.params.conversationId);
        },
        mounted() {
            this.pageLoading = false;
            try {
                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    rest = rest.replaceAll("علامت سوال", "؟");
                    rest = rest.replaceAll("علامت تعجب", "!");
                    rest = rest.replaceAll("علامت بزرگتر", ">");
                    rest = rest.replaceAll("علامت کوچکتر", "<");
                    rest = rest.replaceAll("پرانتز باز", "(");
                    rest = rest.replaceAll("پرانتز بسته", ")");
                    rest = rest.replaceAll("شارپ", "#");
                    rest = rest.replaceAll("ستاره", "*");
                    rest = rest.replaceAll("دو نقطه", ": ");
                    rest = rest.replaceAll("نقطه ویرگول", "; ");
                    rest = rest.replaceAll("نقطه", ". ");


                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("پاراگراف جدید", "\n");
                    rest = rest.replaceAll("پاراگراف بعد", "\n");
                    rest = rest.replaceAll("پاراگراف بعدی", "\n");
                    rest = rest.replaceAll("پاراگراف", "\n");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("خط بعدی", "\n");
                    rest = rest.replaceAll("خط بعد", "\n");
                    rest = rest.replaceAll("خط جدید", "\n");

                    if (this.conversation.folderDescription == null || this.conversation.folderDescription == "null")
                        this.conversation.folderDescription = "";
                    if (rest != null && rest != '')
                        this.conversation.folderDescription = this.conversation.folderDescription + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    rest = "";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
            }
        },
        computed: {
            OrgUnitUserList() {
                return this.$store.getters.GetOrgUnitUserList;
            },
            GetConversationFolders() {
                return this.conversation.conversationFolders;
            },

            PersonList() {
                return this.$store.getters.GetPersonList;
            },
            ProjectList() {
                return this.$store.getters.GetProjectList;
            },
            PreInvoiceList() {
                return this.$store.getters.GetPreInvoiceList;
            },
            ContractList() {
                return this.$store.getters.GetContractList;
            },
            InvoiceList() {
                return this.$store.getters.GetInvoiceList;
            },
            LetterList() {
                return this.$store.getters.GetLetterList;
            },
            MeetingList() {
                return this.$store.getters.GetMeetingList;
            },
            PreBuyInvoiceList() {
                return this.$store.getters.GetPreBuyInvoiceList;
            },
            BuyList() {
                return this.$store.getters.GetBuyList;
            },
            LocalUserListForMention() {
                return this.$store.getters.GetLocalUserListForMention;
            },
            WorkGroupList() {
                return this.$store.getters.GetWorkGroupList;
            },
            HasCom() {
                return this.$store.getters.GetHasCom;
            },
        }

        //beforeRouteLeave(to, from, next) {
        //    if (this.modified == true) {
        //        VueSimpleAlert.fire({
        //            title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
        //            showCancelButton: true,
        //            confirmButtonText: 'تأیید',
        //            cancelButtonText: `انصراف`,
        //        }).then((result) => {
        //            console.log(this.modified);

        //            if (result.value == true) {
        //                next();
        //            } else {
        //                next(false);
        //            }
        //        })
        //    }
        //    else {
        //        next();
        //    }
        //};
    }
</script>